module.exports = __webpack_public_path__ + "img/1_jeff_n.3881128b.png";